import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SIGNOUT } from 'redux/sagas/actions/authentication';
import {
  SET_FORGOT_STEP_EMPTY,
  SET_PREVIOUS_STEP
} from 'redux/slices/authentication';

import routes from 'routing/routes';

import { Button } from 'ui/atoms';

import {
  AccessPane,
  AccessWrapper,
  Blur,
  Foreground,
  Logo,
  LogoOuterWrapper,
  LogoWrapper,
  RowCentered
} from './style';

const AccessLayout = ({
  children,
  setForgotStep,
  forgotStep,
  steps_history,
  setPreviousStep,
  redirectToCreatePassword
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleBackButton = () => {
    setPreviousStep(steps_history[steps_history?.length - 2]);
  };

  const backbtn = () => {
    setForgotStep();
    history.push(routes.signin.path);
  };

  return (
    <AccessWrapper>
      <AccessPane>
        <RowCentered>
          <LogoOuterWrapper>
            <LogoWrapper>
              <Logo />
            </LogoWrapper>
          </LogoOuterWrapper>
        </RowCentered>
        <Blur />
        <Foreground>
          {children}
          <RowCentered>
            {redirectToCreatePassword ? (
              <Button variant="login-cancel" onClick={backbtn}>
                {t('cancel')}
              </Button>
            ) : null}
            {forgotStep !== 'login' && forgotStep !== 'newPasswordSuccess' ? (
              <Button variant="login-cancel" onClick={handleBackButton}>
                {t('cancel')}
              </Button>
            ) : null}
          </RowCentered>
        </Foreground>
      </AccessPane>
    </AccessWrapper>
  );
};

AccessLayout.propTypes = {
  children: PropTypes.node,
  setForgotStep: PropTypes.func,
  forgotStep: PropTypes.string,
  steps_history: PropTypes.array,
  setPreviousStep: PropTypes.func,
  redirectToCreatePassword: PropTypes.bool
};

export default connect(
  ({ authentication }) => ({
    forgotStep: authentication.forgotStep,
    steps_history: authentication.steps_history,
    redirectToCreatePassword: authentication.redirectToCreatePassword
  }),
  dispatch => ({
    setForgotStep: () => dispatch({ type: SET_FORGOT_STEP_EMPTY }),
    setPreviousStep: step => dispatch(SET_PREVIOUS_STEP(step)),
    signOut: () => dispatch({ type: SIGNOUT._REQUEST })
  })
)(AccessLayout);
